import { RSAA } from 'redux-api-middleware';
import { REQUEST_PASSWORD_RECOVERY } from './types';
import { userAccountIsUnauthenticatedSelector as isUnauthenticatedSelector } from '../selectors/isUnauthenticated';

const paramsToBody = ({ email }) => ({ email });

const requestApiAction = (params) => ({
  [RSAA]: {
    endpoint: '/v2/user/forgot-password',
    method: 'POST',
    credentials: 'include',
    body: paramsToBody(params),
    types: [
      REQUEST_PASSWORD_RECOVERY.REQUEST,
      REQUEST_PASSWORD_RECOVERY.SUCCESS,
      REQUEST_PASSWORD_RECOVERY.FAILURE,
    ],
  },
});

export const userAccountRequesPasswordRecoveryThunkAction = (params) => async (
  dispatch,
  getState,
) => {
  const isUnauthenticated = isUnauthenticatedSelector(getState());

  if (isUnauthenticated) {
    await dispatch(requestApiAction(params));
  }
};
